import { useEffect, useState } from 'react'

import {
  faAngular,
  faDocker,
  faJava,
  faVuejs,
} from '@fortawesome/free-brands-svg-icons'
import {
  faCloud,
  faCubes,
  faDharmachakra,
  faLink,
  faMountain,
  faRobot,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Loader from 'react-loaders'
import { Link } from 'react-router-dom'

import AnimatedLetters from '../AnimatedLetters'
import Terminal from '../Terminal'
import './index.scss'

const techBadges = [
  { icon: faJava, label: 'Java', color: '#f89820' },
  { icon: faAngular, label: 'Angular', color: '#dd0031' },
  { icon: faVuejs, label: 'Vue', color: '#42b883' },
  { icon: faDocker, label: 'Docker', color: '#2496ed' },
  { icon: faCloud, label: 'Azure', color: '#0078d4' },
  { icon: faDharmachakra, label: 'Kubernetes', color: '#326ce5' },
  { icon: faCubes, label: 'Microservices', color: '#22d3ee' },
  { icon: faMountain, label: 'Nuxt', color: '#00dc82' },
  { icon: faLink, label: 'LangChain', color: '#2bbb8f' },
  { icon: faRobot, label: 'CrewAI', color: '#ff5e3a' },
]

const Home = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  const nameArray = 'Touheed.'.split('')
  const jobArray = 'Staff Engineer'.split('')

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 4000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <div className="container home-page">
        <div className="text-zone">
          <span className="hero-kicker">
            <span className="kicker-dot" />
            Available for new opportunities
          </span>
          <h1>
            <span className={letterClass}>H</span>
            <span className={`${letterClass} _12`}>i,</span>
            <br />
            <span className={`${letterClass} _13`}>I</span>
            <span className={`${letterClass} _14`}>'m</span>{' '}
            <span className="hero-name">
              <AnimatedLetters
                letterClass={letterClass}
                strArray={nameArray}
                idx={15}
              />
            </span>
            <br />
            <AnimatedLetters
              letterClass={letterClass}
              strArray={jobArray}
              idx={23}
            />
          </h1>
          <div className="hero-chips">
            <span className="hero-chip">Java Full Stack</span>
            <span className="hero-chip">AI</span>
            <span className="hero-chip">Microservices</span>
            <span className="hero-chip">11+ Years</span>
          </div>
          <h2>
            Delivering IT solutions, building industry-grade applications and
            leading technical excellence.
          </h2>
          <div className="hero-actions">
            <Link to="/contact" className="flat-button primary">
              CONTACT ME
            </Link>
            <Link to="/projects" className="flat-button ghost">
              VIEW PROJECTS
            </Link>
          </div>
        </div>

        <div className="hero-visual">
          <div className="glow-orb orb-1" />
          <div className="glow-orb orb-2" />

          <Terminal />

          {techBadges.map((badge, i) => (
            <div key={badge.label} className={`float-badge badge-${i + 1}`}>
              <FontAwesomeIcon icon={badge.icon} style={{ color: badge.color }} />
              <span>{badge.label}</span>
            </div>
          ))}
        </div>
      </div>

      <Loader type="pacman" />
    </>
  )
}

export default Home
